document.addEventListener('DOMContentLoaded', function () {
    initFollowTextScroll();
    initVariantPickerUnderline();
});

// Delegated on document (not bound per label) because the variant picker is
// re-rendered or gets options injected after load (tallas-hermanadas.js, product
// switching, quick view). Per-element listeners were lost when that happened.
function initVariantPickerUnderline() {
    if (window.__variantPickerUnderline) {
        document.querySelectorAll('variant-selects').forEach(syncVariantUnderline);
        return;
    }
    window.__variantPickerUnderline = true;

    document.addEventListener('mouseover', function (event) {
        var label = event.target.closest && event.target.closest('variant-selects label');
        if (!label) return;
        var picker = label.closest('variant-selects');
        if (picker.querySelector('.variant_picker__underline')) moveVariantUnderlineTo(picker, label);
    });

    document.addEventListener('mouseout', function (event) {
        var picker = event.target.closest && event.target.closest('variant-selects');
        if (!picker || picker.contains(event.relatedTarget)) return;
        syncVariantUnderline(picker);
    });

    document.addEventListener('change', function (event) {
        var picker = event.target.closest && event.target.closest('variant-selects');
        if (!picker || event.target.type !== 'radio') return;
        requestAnimationFrame(function () { syncVariantUnderline(picker); });
    });

    // Anything that re-renders or injects options inside a picker re-syncs it.
    var pending = false;
    new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
            pending = false;
            document.querySelectorAll('variant-selects').forEach(syncVariantUnderline);
        });
    }).observe(document.body, { childList: true, subtree: true });

    window.addEventListener('resize', function () {
        document.querySelectorAll('variant-selects').forEach(syncVariantUnderline);
    });

    document.querySelectorAll('variant-selects').forEach(syncVariantUnderline);
}

function moveVariantUnderlineTo(picker, label) {
    var underline = picker.querySelector('.variant_picker__underline');
    if (!underline) return;

    var heightElement = document.querySelector('.variations');
    var height = heightElement ? heightElement.offsetHeight : 0;

    var fRect = picker.getBoundingClientRect();
    var lRect = label.getBoundingClientRect();

    if (height > 75) {
        underline.style.top = (-90 + (lRect.bottom - fRect.top)) + 'px';
    }

    underline.style.left = (lRect.left - fRect.left) + 'px';
    underline.style.bottom = 'auto';
    underline.style.width = lRect.width + 'px';
    underline.style.opacity = '1';
}

function syncVariantUnderline(picker) {
    var underline = picker.querySelector('.variant_picker__underline');
    if (!underline) return;

    var checked = picker.querySelector('input[type="radio"]:checked');
    var label = checked && picker.querySelector('label[for="' + checked.id + '"]');
    if (label) {
        moveVariantUnderlineTo(picker, label);
    } else {
        underline.style.opacity = '0';
    }
}

function initFollowTextScroll() {
    var contents = document.querySelectorAll('.gallery--item-content.follow-text');
    if (!contents.length) return;

    var ticking = false;

    function update() {
        contents.forEach(function (content) {
            var textEl = content.querySelector(':scope > div');
            if (!textEl) return;

            var figure = content.closest('figure') || content.parentElement;
            var figRect = figure.getBoundingClientRect();
            var figHeight = figRect.height;
            var textHeight = textEl.offsetHeight;

            var scrollPast = (window.innerHeight / 2) - (figRect.top + figHeight / 2);

            if (scrollPast <= 0) {
                textEl.style.transform = 'translateY(0)';
                return;
            }

            var maxTranslate = Math.max(0, (figHeight - textHeight) / 2 - 40);
            var translate = Math.min(scrollPast, maxTranslate);
            textEl.style.transform = 'translateY(' + translate + 'px)';
        });
    }

    window.addEventListener('scroll', function () {
        if (!ticking) {
            requestAnimationFrame(function () {
                update();
                ticking = false;
            });
            ticking = true;
        }
    }, { passive: true });

    update();
}


// variant_picker__underline move through options

// hide facets-grid-container-fixed when facets-bar is not visible

document.addEventListener('DOMContentLoaded', function () {
    var facetsBarOriginal = document.querySelector('#facets-grid-container');
    if (!facetsBarOriginal) return;

    var facetsBarFixed = document.querySelector('#facets-grid-container-fixed');
    if (!facetsBarFixed) return;

    var lastScrollY = window.scrollY;

    async function updateFacetsBarFixedVisibility(isScrollingUp) {
        var rect = facetsBarOriginal.getBoundingClientRect();

        // Show only while scrolling up and the original facets bar is above the viewport.
        if (isScrollingUp && rect.bottom < 0) {
            facetsBarFixed.classList.add('show-facets-bar');
            await new Promise(function (resolve) {
                facetsBarFixed.classList.remove('hide-facets-bar');
                facetsBarFixed.style.display = 'grid';
                resolve();
            }, 500);
            facetsBarFixed.classList.remove('hide-facets-bar');
        } else {
            facetsBarFixed.classList.remove('show-facets-bar');
            facetsBarFixed.classList.add('hide-facets-bar');
            
            await new Promise(function (resolve) {
                setTimeout(function () {
                    
                    facetsBarFixed.style.display = 'none';
                    resolve();
                }, 500);
            });
        }
    }

    window.addEventListener('scroll', function () {
        var currentScrollY = window.scrollY;
        var isScrollingUp = currentScrollY < lastScrollY;

        updateFacetsBarFixedVisibility(isScrollingUp);
        lastScrollY = currentScrollY;
    }, { passive: true });

    facetsBarFixed.style.display = 'none';

});